<template>
  <!-- 管理员消息管理 -->
  <div class="main-css">
    <!--标题-->
    <div class="title-css">{{$t('messageManagement')}}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="infoMessageDelete">{{$t('delete')}}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" style="width: 95%" height="520" @sort-change="changeTableSort"
          @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------送信者番号---------------------- -->
          <el-table-column prop="sendId" label="送信者番号" width="110px" :show-overflow-tooltip="true">
            <!-- eslint-disable-next-line -->
            <template slot="header">
              <p>{{ $t("senderNumber") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.sendId }}
            </template>
          </el-table-column>
          <!-- ----------------------送信者氏名---------------------- -->
          <el-table-column prop="sendName" label="送信者氏名" width="110px" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("senderName") }}</p>
              <el-input v-model="searchData2" size="mini" placeholder="Search" @input="inputSearch" clearable />
            </template>
            <template slot-scope="scope">
              {{ scope.row.sendName }}
            </template>
          </el-table-column>
          <!-- ---------------------受信者番号-------------------- -->
          <el-table-column prop="receiveId" label="受信者番号" width="110px" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("recipientNumber") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.receiveId }}
            </template>
          </el-table-column>

          <!-- ----------------------受信者氏名---------------------- -->
          <el-table-column prop="receiveName" label="受信者氏名" width="110px" :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("trusteeName") }}</p>
              <el-input v-model="searchData4" size="mini" placeholder="Search" @input="inputSearch"  clearable/>
            </template>
            <template slot-scope="scope">
              {{ scope.row.receiveName }}
            </template>
          </el-table-column>
          <!-- -----------------------送信時刻----------------------- -->
          //
          <el-table-column prop="msgTime" label="送信時刻" min-width="210"  :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("deliveryTime") }}</p>
              <el-date-picker v-model="searchData1" type="datetimerange" range-separator="~" :start-placeholder="$t('deliveryTimein')"
                :end-placeholder="$t('deliveryTimeout')" class="data-timer-picker" @blur="dataTimeChange" format="yyyy-MM-dd HH-mm-ss">
              </el-date-picker>
            </template>

            <!-- <template sortable> -->
            <template slot-scope="scope">
              {{ scope.row.msgTime }}
            </template>
            <!-- </template> -->
          </el-table-column>
          <!-- ------------------------聊天来源------------------------ -->
          <el-table-column prop="msgStatus" label="聊天来源" width="110px" :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("chatSource") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span v-if="language==='CN'">
                {{scope.row.msgType_dictText}}
              </span>
              <span v-else>
                {{scope.row.jpmsgType_dictText}}
              </span>
            </template>
          </el-table-column>
          <!-- ------------------------チャット内容------------------------ -->
          <el-table-column prop="content" label="チャット内容" min-width="200" :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("chatContent") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.content }}
            </template>
          </el-table-column>
          <!-- ------------------------信息状态------------------------ -->
          <el-table-column prop="msgStatus" label="信息状态" width="110px" :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("informationStatus") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span v-if="language==='CN'">
                {{scope.row.msgStatus_dictText}}
              </span>
              <span v-else>
                {{scope.row.jpmsgStatus_dictText}}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" layout=" prev, pager, next"
            :total="totalNum" :page-size="pageSize">
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">10</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { messageBaseQuery, messageDelete, messageFuzzyQuery } from "../../js/api"
import AES from "../../js/AES";
import dateFormat from "../../js/time"
export default {
  name: "medicalStaffManagement",
  components: {},
  data() {
    return {
      inputData1: "", //搜索框input内容
      tableData: [],
      // searchData1: [new Date(2024, 10, 10, 10, 10), new Date(2030, 10, 11, 10, 10)], //日期时间
      searchData1: ["", ""], //日期时间
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 10, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      totalNum: 0,
      msgIdList: [],//消息id的list用来删除用的
      startTime: "",
      endTime: "",
      language:"",

    };
  },
  created() {
    this.language=window.localStorage.getItem('language')

    this.getListInfo()//列表基础信息
  },
  computed: {
    //搜索部分的placeholder
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    },
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        this.getListInfo()//列表基础信息
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    //pagination 页数修改
    handleCurrentChange(evt) {
      this.currentPage = evt
      this.getListInfo()
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 10;
        console.log(this.pageSize);
        this.getListInfo()
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
        this.getListInfo()
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
        this.getListInfo()
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
        this.getListInfo()
      }
    },
    //列表选择 出消息id list
    handleSelectionChange(val) {
      this.msgIdList = []
      console.log(val)
      for (var i = 0; i < val.length; i++) {
        this.msgIdList.push(val[i].msgId)
      }
      console.log(this.msgIdList)
    },
    //日期筛选
    organAttributeClick(evt) {
      if (evt === "0") {
        //全部
        console.log(evt);
      } else if (evt === "1") {
        console.log(evt);
      } else if (evt === "2") {
        console.log(evt);
      }
    },
    //消息列表 整体查询
    getListInfo() {
      const infoItem = {
        isDelete: "",
        msgContent: "",
        msgStatus: "",
        msgTimeIn: "",
        msgTimeOut: "",
        msgType: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        systemId: "",
        typeId: "",
        userId: ""
      }
      // const AesInfoItem = AES.encrypt(JSON.stringify(infoItem));
      messageBaseQuery(infoItem).then((res) => {
        console.log("----管理员消息list接口----")
        console.log(res)
        if (res.data.code === "A0000") {
          const AesDeInfo = JSON.parse(AES.decrypt(res.data.data))
          console.log(AesDeInfo)
          this.tableData = AesDeInfo.data
          this.totalNum = AesDeInfo.total
        }
      }).catch((res) => {

      })
    },
    //消息删除
    infoMessageDelete() {
      if (this.msgIdList.length === 0) {
        this.$message({
          message:this.$t('selectLeastOneMessage'),
          type: 'warning'
        });
      } else {
        const infoItem = {
          listId: this.msgIdList
        }
        messageDelete(infoItem).then((res) => {
          console.log("--------管理员消息删除接口信息--------")
          console.log(res)
          if (res.data.code === "A0000") {
            this.getListInfo()
            this.$message({
              message: this.$t('successfullyDeleted'),
              type: 'success'
            });
          }
          else {
            this.$message.error(this.$t('failedToDelete'));
          }
        }).catch((res) => {
          console.log("-------------管理员消息删除接口信息-------------")
        })
      }

    },
    //search
    inputSearch() {
      this.messageFuzzyQueryList()
    },
    //data -time 选择
    dataTimeChange() {
      console.log(this.searchData1)
      this.startTime = this.timeJs(this.searchData1[0])
      this.endTime = this.timeJs(this.searchData1[1])
      this.messageFuzzyQueryList()
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = ' 星期' + '日一二三四五六'.charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes()
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //消息模糊查询
    messageFuzzyQueryList() {
      var fakeItem = {
        content: "",
        msgTimeIn: this.startTime,
        msgTimeOut: this.endTime,
        msgType: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        receiveId: "",
        receiveName: this.searchData4,
        sendId: "",
        sendName: this.searchData2
      }
      messageFuzzyQuery(fakeItem).then((res) => {
        console.log("----平台管理消息模糊查询----")
        console.log(res)
        if (res.data.code === "A0000") {
          const AesDeInfo = JSON.parse(AES.decrypt(res.data.data))
          console.log(AesDeInfo)
          this.tableData = AesDeInfo.data
        }
      }).catch((res) => {
        console.log("----平台管理消息模糊查询----")
        console.log(res)
      })
    }
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.table /deep/ .el-date-editor {
  width: 210px;
}

.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  width: 100%;
  margin-top: 10px;
  height: 520px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.operate {
  height: 51px;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}

.pagination {
  width: 95%;
  height: 50px;
  margin-top: 60px;
}

.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.data-timer-picker{
  height: 32px;
}
</style>




// WEBPACK FOOTER //
// src/pages/administratorInformationManagement/index.vue